// Import the functions you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyC3ZA9XHptwzd-rfRzJtcQAuGs89wKlVOo",
  authDomain: "game-7-7ec4d.firebaseapp.com",
  projectId: "game-7-7ec4d",
  storageBucket: "game-7-7ec4d.firebasestorage.app",
  messagingSenderId: "503468213047",
  appId: "1:503468213047:web:4f8f709b1da9ecc57050b2",
  measurementId: "G-XMV5RQK0K7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Analytics only when browser supports it
let analytics = null;

isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

// Firestore
const db = getFirestore(app);

export { app, db, analytics };
